const NavBarUserIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
        <path d="M6.57757 16.3623C5.1628 17.2047 1.45336 18.9248 3.71266 21.0773C4.81631 22.1287 6.04549 22.8807 7.59087 22.8807H16.4091C17.9545 22.8807 19.1837 22.1287 20.2873 21.0773C22.5466 18.9248 18.8372 17.2047 17.4224 16.3623C14.1048 14.3868 9.89519 14.3868 6.57757 16.3623Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M16.5 7.38075C16.5 9.86603 14.4853 11.8808 12 11.8808C9.51472 11.8808 7.5 9.86603 7.5 7.38075C7.5 4.89547 9.51472 2.88075 12 2.88075C14.4853 2.88075 16.5 4.89547 16.5 7.38075Z" stroke="black" stroke-width="1.5"/>
      </svg>
    )
}
export default NavBarUserIcon;